"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typeChecks_1 = require("./typeChecks");

var intlInstanceCache_1 = require("./intlInstanceCache");

var transform_1 = require("./transform");

var collection_1 = require("./collection");

var date_1 = require("./date");

exports.padStart = function (value, length, padder) {
  if (padder === void 0) {
    padder = '0';
  }

  if (value !== undefined && value !== null) {
    var response = value.toString();

    if (response.length < length) {
      var split = response.split('');

      while (split.length < length) {
        split.unshift(padder);
      }

      response = split.join('');
    }

    return response;
  }

  return '';
};

exports.formatNumber = function (locale, options, value, translate) {
  if (locale === void 0) {
    locale = 'en-GB';
  }

  if (typeChecks_1.isNumber(value)) {
    try {
      var numberThresholds = options.numberThresholds,
          _a = options.thresholdSeparator,
          thresholdSeparator = _a === void 0 ? '' : _a,
          _b = options.forceMinimumThresholdFormatting,
          forceMinimumThresholdFormatting = _b === void 0 ? false : _b;
      var numberThreshold = void 0;

      if (numberThresholds) {
        var sortedNumberThresholds = collection_1.sortBy(numberThresholds, function (item) {
          return item.value.toString();
        }, 'DESC');

        for (var _i = 0, sortedNumberThresholds_1 = sortedNumberThresholds; _i < sortedNumberThresholds_1.length; _i++) {
          var numberGroup = sortedNumberThresholds_1[_i];
          var thresholdValue = numberGroup.value;
          var shouldFormat = sortedNumberThresholds.indexOf(numberGroup) === sortedNumberThresholds.length - 1 && value < thresholdValue && forceMinimumThresholdFormatting;

          if (value >= thresholdValue || shouldFormat) {
            numberThreshold = numberGroup;
            value = value / thresholdValue;
            break;
          }
        }
      }

      var formattedNumber = intlInstanceCache_1.default.getNumber(locale, options).format(value);

      if (numberThreshold) {
        var text = numberThreshold.text,
            _c = numberThreshold.separator,
            separator = _c === void 0 ? thresholdSeparator : _c,
            _d = numberThreshold.displayPosition,
            displayPosition = _d === void 0 ? 'suffix' : _d;
        var translatedText = translate && translate(text) || text;

        if (displayPosition === 'suffix') {
          return "" + formattedNumber + separator + translatedText;
        }

        if (displayPosition === 'prefix') {
          return "" + translatedText + separator + formattedNumber;
        }
      }

      return formattedNumber;
    } catch (e) {
      console.warn(e);
      return value;
    }
  }

  return value;
};

var getFormatSymbolData = function getFormatSymbolData(format, symbolChar) {
  var formatCharacters = format.split('');
  var start;
  var length = 0;

  for (var i = 0; i < formatCharacters.length; i++) {
    var char = formatCharacters[i];
    var prevChar = i > 0 ? formatCharacters[i - 1] : null;

    if (start === undefined) {
      if (char === symbolChar) {
        start = i;
        length++;
      }
    } else if (prevChar === symbolChar && char === symbolChar) {
      length++;
    }
  }

  return {
    start: start,
    length: length,
    key: format.slice(start, start + length)
  };
};

var getDatePart = function getDatePart(date, symbol, key, defaultPart) {
  if (date && symbol && symbol.length > 0 && symbol.key === key) {
    return date.slice(symbol.start, symbol.start + symbol.length);
  }

  return defaultPart;
};

var dateFromFormat = function dateFromFormat(date, fromFormat) {
  if (date && fromFormat !== 'YYYY-MM-DD') {
    var symbols = {
      year: getFormatSymbolData(fromFormat, 'Y'),
      month: getFormatSymbolData(fromFormat, 'M'),
      day: getFormatSymbolData(fromFormat, 'D'),
      hour: getFormatSymbolData(fromFormat, 'H'),
      minute: getFormatSymbolData(fromFormat, 'm'),
      second: getFormatSymbolData(fromFormat, 'S')
    };
    var formattedDateString = '';
    formattedDateString += getDatePart(date, symbols.year, 'YYYY') + "-";
    formattedDateString += getDatePart(date, symbols.month, 'MM') + "-";
    formattedDateString += getDatePart(date, symbols.day, 'DD') + "T";
    formattedDateString += getDatePart(date, symbols.hour, 'HH', '00') + ":";
    formattedDateString += getDatePart(date, symbols.minute, 'mm', '00') + ":";
    formattedDateString += "" + getDatePart(date, symbols.second, 'SS', '00');
    return new Date(formattedDateString);
  }

  return new Date(date);
};

exports.formatDateTime = function (locale, options, value, translate) {
  if (locale === void 0) {
    locale = 'en-GB';
  }

  var fromDateFormat = options.fromDateFormat || 'YYYY-MM-DD'; // Cleans up dates coming in with a format of YYYY-MM-DD HH:mm:SS, it will change them to
  // YYYY-MM-DDTHH:mm:SS. This is required for how IE11 handles value format for the new Date(value).

  var dateRegex = new RegExp(/(\d){4}-(\d){2}-(\d){2} (\d){2}\:(\d){2}\:(\d){2}/);

  if (typeof value === 'string' && dateRegex.test(value)) {
    value = value.replace(' ', 'T');
  }

  var date = dateFromFormat(value, fromDateFormat);
  var isValidDate = typeChecks_1.isDate(date) && !typeChecks_1.isNaN(date.getTime());

  if (isValidDate) {
    try {
      var dateFormatString = options.dateFormatString;

      if (dateFormatString) {
        return date_1.formatDateWithStringFormat(date, dateFormatString, translate);
      }

      return intlInstanceCache_1.default.getDateTime(locale, options).format(date);
    } catch (e) {
      console.warn(e);
      return value;
    }
  }

  return value;
};

exports.formatter = function (format, value, translate) {
  var type = format.type,
      locale = format.locale,
      currency = format.currency,
      options = format.options,
      transforms = format.transforms;
  return spreadFormatter(type, locale, currency, options, value, transforms, translate);
};

var spreadFormatter = function spreadFormatter(type, locale, currency, options, value, transforms, translate) {
  var _a;

  if (locale === void 0) {
    locale = 'en-GB';
  }

  if (options === void 0) {
    options = {};
  }

  var response = value;
  var placeholderText = options.placeholderText,
      _b = options.placeholderKey,
      placeholderKey = _b === void 0 ? 'value' : _b;

  if (transforms && typeChecks_1.isNumber(value)) {
    var typesAllowedToTransform = ['number', 'percent', 'currency'];

    if (typesAllowedToTransform.includes(type)) {
      value = transform_1.transform(value, transforms);
    }
  }

  if (type === 'string') {
    response = !typeChecks_1.isNullOrUndefined(value) && value.toString();
  }

  if (type === 'number') {
    response = exports.formatNumber(locale, options, value, translate);
  }

  if (type === 'percent') {
    var workingOptions = Object.assign({}, options || {}, {
      style: 'percent'
    });
    response = exports.formatNumber(locale, workingOptions, value, translate);
  }

  if (type === 'currency') {
    var workingOptions = Object.assign({}, options || {}, {
      style: 'currency'
    });
    workingOptions.currency = currency;
    response = exports.formatNumber(locale, workingOptions, value, translate);
  }

  if (type === 'date') {
    response = exports.formatDateTime(locale, options, value);
  }

  if (translate && placeholderText) {
    response = translate(placeholderText, (_a = {}, _a[placeholderKey] = response, _a));
  }

  return response;
};

exports.default = spreadFormatter;